import { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import "../../components/shopItemsView/shopitemview.css";
import { Row, Col, Container } from "react-bootstrap";
import BackArrow from "../../components/backArrow";
import CallIcon from "@mui/icons-material/Call";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import RedoIcon from "@mui/icons-material/Redo";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { SuccessNotify } from "../../constants/tostify";
import { FailedNotify } from "../../constants/tostify";
import url from "../../config/axios";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { getAsset } from "../../helpers/helper";
import UpdateServiceModal from "../../components/Servicemodal_one_update";
import UpdateExperienceModal from "../../components/Service_Experience_update";
import { useSearchParams } from "react-router-dom";
import { MainModal } from "@/components";
import { useGetCertExpeSerQuery } from "../../features/service/serviceApiSlice";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
const ServiceViewbuying = () => {
  const { name } = useSelector((state) => state.user);
  const { id, serviceid } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const location = useLocation();
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const handleClose = () => setShows(0);
  const [increase, setIncrease] = useState(1);
  const [Itemdata, setItemsData] = useState();
  const [show, setShow] = useState(0);
  const [shows, setShows] = useState(false);
  const [showModal, setShowModal] = useState(0);

  const handleModal = (e) => {
    setShowModal(e);
  };

  const Deleteitem = () => {
    setShows(0);
    setIsloading(true);
    url
      .delete(`fooditem/?id=${id}`)
      .then(async (response) => {
        if (response.data.success) {
          setIsloading(false);
          SuccessNotify("Item Deleted Successfully");
          navigate(`/RestaurantAlldata/${Itemdata.shopid}`);
        }
      })
      .catch((e) => {
        setIsloading(false);
        FailedNotify("Failed to Delete Try Again!");
      });
  };

  const [showmodal, setShowmodal] = useState(false);
  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);

  const [showshare, setShowshare] = useState(false);
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  const [servicesdata, setServicesdata] = useState([]);
  useEffect(() => {
    if (Itemdata) {
      const thumimgs = document?.querySelectorAll(
        ".image-gallery-thumbnail-image",
      );
      thumimgs?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [Itemdata]);

  useEffect(() => {
    if (Itemdata) {
      const img = document?.querySelectorAll(".image-gallery-image");
      img?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [Itemdata]);

  const { data: certData, isLoading: isCertLoading } = useGetCertExpeSerQuery(
    { serviceid, type, id },
    { skip: !serviceid || !id }
  );

  useEffect(() => {
    if (certData?.data?.item) {
      setItemsData(certData.data.item);
    }
  }, [certData]);

  const ShopModelCarousal =
    Itemdata?.images?.map((image, index) => ({
      id: index + 1,
      original: image ? getAsset(image) : noImagePlaceholder,
      thumbnail: image ? getAsset(image) : noImagePlaceholder,
    })) || [];

  return (
    <>
      <UpdateServiceModal
        show={showModal}
        handleClose={() => setShowModal(0)}
      />

      <UpdateExperienceModal
        show={showModal}
        handleClose={() => setShowModal(0)}
      />
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
      />
      {shows === 1 && (
        <MainModal
          variant="deleteModal"
          shows={shows}
          title="Profile"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
        />
      )}
      <Container>
        <div className="screenHeight">
          <div className="ps-5">
            {/* <h5>{moment(Itemdata?.createdAt).format("DD MMM YYYY, h:mm A")}</h5> */}
            {/* <h5>Time</h5> */}
          </div>
          <Row>
            <Col lg="6">
              <div className="row">
                <ImageGallery
                  showPlayButton={false}
                  showFullscreenButton={false}
                  items={ShopModelCarousal}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="ps-4 pe-4 pt-4 pb-1 bg-vilot View-Model-Shadow">
                {isloading === true ? (
                  <Loader heightsetting="screenHeight" />
                ) : (
                  <Row className="ps-5 pe-5">
                    <BackArrow mystyle="ps-0" />
                    <Col lg="6" md="6" sm="6" xs="6" className="mt-3">
                      <h5 className="">
                        {Itemdata?.heading || Itemdata?.name}
                      </h5>
                    </Col>
                    <Col lg="6" md="6" sm="6" xs="6" className="text-end mt-3">
                      <button className="shareItembtn" onClick={handleShow}>
                        Share <RedoIcon className="share_icon_f" />
                      </button>
                    </Col>

                    <div>
                      <h6 className="">
                        {Itemdata?.projectName ? Itemdata?.projectName : ""}
                      </h6>
                    </div>
                    <div>
                      <p
                        className="mb-0 font_14 text-justify"
                        style={{ lineHeight: "30px" }}
                      >
                        {Itemdata?.detail}
                      </p>
                      {/* <p className="mb-0">{name.email}</p>
                      <p className="mb-0">{Itemdata?.contact}</p> */}
                    </div>

                    <div className="pt-4 d-flex">
                      <button className="d-flex align-items-center border rounded ps-3 pe-3 pt-1 pb-1 bg-blue text-white">
                        <ChatBubbleIcon />
                        <span className="ps-1">Message</span>
                      </button>
                      <button className="d-flex align-items-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 text-white">
                        <CallIcon />
                        <span className="ps-1">Call</span>
                      </button>
                    </div>
                  </Row>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default ServiceViewbuying;
